import PropTypes from 'prop-types';
import React from 'react';

import MillesimaLink from '@/components/common/MillesimaLink';
import styles from './ArticleTagList.module.scss';
import { HTML_ENTITY } from '@/constants/htmlEntity';
import { PAGES } from '@/constants/pages';

export const ArticleTagList = ({ tags, centered = false, articlePage = false }) => {
  const contentPositionClassName = `position-${!centered ? 'start' : 'center'}${!articlePage ? '-not-article-page' : ''}`;

  return (
    <div className={`${styles['tags-container']} ${styles[contentPositionClassName]}`} data-rbf="article-tag-list">
      {tags?.map((tag, index) =>
        <React.Fragment key={tag.id}>
          <MillesimaLink
            id={`article-card-tag-${tag.id}`}
            key={tag.id}
            href={`${PAGES.BLOG}/${tag.content[0].urlKeyword}`}
            target="_blank"
            ariaLabel="TagLink"
            customClassName={{ link: styles['tag-link'] }}
            isNextLink={true}
          >{tag.content[0].title}
          </MillesimaLink>
          <span className={styles['tags-circle']}>
            {index !== tags.length - 1 ? HTML_ENTITY.BLACK_CIRCLE : ''}
          </span>
        </React.Fragment>
      )}
    </div>
  );
};

ArticleTagList.propTypes = {
  tags: PropTypes.array,
  centered: PropTypes.bool,
  articlePage: PropTypes.bool
};

export default ArticleTagList;
